import { createVNode as _createVNode, resolveComponent as _resolveComponent, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, withCtx as _withCtx, resolveDirective as _resolveDirective, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = { class: "bg-ff table-content" }
const _hoisted_2 = { class: "flex alignC top-button-group" }
const _hoisted_3 = /*#__PURE__*/_createVNode("span", { class: "c-60 mar-r-8 mar-l-16" }, "开单时间", -1)
const _hoisted_4 = /*#__PURE__*/_createVNode("span", { class: "c-60 mar-r-8 mar-l-16" }, "服务类型", -1)
const _hoisted_5 = /*#__PURE__*/_createVNode("span", { class: "c-60 mar-r-8 mar-l-16" }, "车型", -1)
const _hoisted_6 = /*#__PURE__*/_createVNode("span", { class: "c-ff" }, "搜索", -1)
const _hoisted_7 = /*#__PURE__*/_createVNode("span", { class: "c-ff f-12" }, "恢复工单", -1)
const _hoisted_8 = { class: "flex flexR mar-t-22" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_date_picker = _resolveComponent("el-date-picker")
  const _component_el_option = _resolveComponent("el-option")
  const _component_el_select = _resolveComponent("el-select")
  const _component_el_input = _resolveComponent("el-input")
  const _component_el_button = _resolveComponent("el-button")
  const _component_el_table_column = _resolveComponent("el-table-column")
  const _component_el_table = _resolveComponent("el-table")
  const _component_el_pagination = _resolveComponent("el-pagination")
  const _directive_loading = _resolveDirective("loading")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", _hoisted_2, [
      _hoisted_3,
      _createVNode(_component_el_date_picker, {
        modelValue: _ctx.selectGroup.date,
        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.selectGroup.date = $event)),
        class: "mar-r-8",
        type: "daterange",
        "unlink-panels": "",
        "range-separator": "-",
        "start-placeholder": "开始日期",
        "end-placeholder": "结束日期",
        onChange: _ctx.getTableData
      }, null, 8, ["modelValue", "onChange"]),
      _hoisted_4,
      _createVNode(_component_el_select, {
        class: "mar-r-8",
        style: {"width":"114px"},
        modelValue: _ctx.selectGroup.project_type_id,
        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_ctx.selectGroup.project_type_id = $event)),
        placeholder: "请选择",
        clearable: "",
        onChange: _ctx.getTableData
      }, {
        default: _withCtx(() => [
          (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.select.project_type_data, (item) => {
            return (_openBlock(), _createBlock(_component_el_option, {
              label: item.basicset_name,
              value: item.basicset_id,
              key: item.basicset_id
            }, null, 8, ["label", "value"]))
          }), 128))
        ]),
        _: 1
      }, 8, ["modelValue", "onChange"]),
      _hoisted_5,
      _createVNode(_component_el_select, {
        class: "mar-r-8",
        style: {"width":"108px"},
        modelValue: _ctx.selectGroup.car_brand_id,
        "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (_ctx.selectGroup.car_brand_id = $event)),
        placeholder: "请选择",
        clearable: "",
        filterable: "",
        onChange: _ctx.brandChange
      }, {
        default: _withCtx(() => [
          (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.select.car_brand_data, (item) => {
            return (_openBlock(), _createBlock(_component_el_option, {
              label: item.brand_name,
              value: item.id,
              key: item.id
            }, null, 8, ["label", "value"]))
          }), 128))
        ]),
        _: 1
      }, 8, ["modelValue", "onChange"]),
      _createVNode(_component_el_select, {
        class: "mar-r-18",
        style: {"width":"132px"},
        modelValue: _ctx.selectGroup.car_series_id,
        "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => (_ctx.selectGroup.car_series_id = $event)),
        placeholder: "请选择",
        disabled: !_ctx.selectGroup.car_brand_id,
        clearable: "",
        onChange: _ctx.getTableData
      }, {
        default: _withCtx(() => [
          (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.select.car_series_data, (item) => {
            return (_openBlock(), _createBlock(_component_el_option, {
              label: item.series_name,
              value: item.id,
              key: item.id
            }, null, 8, ["label", "value"]))
          }), 128))
        ]),
        _: 1
      }, 8, ["modelValue", "disabled", "onChange"]),
      _createVNode(_component_el_input, {
        class: "mar-l-16 mar-r-18",
        modelValue: _ctx.selectGroup.search,
        "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => (_ctx.selectGroup.search = $event)),
        placeholder: "单据编号/车牌/送修人/手机号",
        "suffix-icon": "el-icon-search",
        style: {"width":"230px"},
        clearable: "",
        onChange: _ctx.getTableData
      }, null, 8, ["modelValue", "onChange"]),
      _createVNode(_component_el_button, {
        class: "bg-red",
        onClick: _ctx.getTableData
      }, {
        default: _withCtx(() => [
          _hoisted_6
        ]),
        _: 1
      }, 8, ["onClick"])
    ]),
    _createVNode("div", null, [
      _withDirectives(_createVNode(_component_el_table, {
        data: _ctx.tableData,
        stripe: "",
        style: {"width":"100%"},
        class: "table",
        "header-cell-style": _ctx.headClass
      }, {
        default: _withCtx(() => [
          (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.columnList, (item, index) => {
            return (_openBlock(), _createBlock(_component_el_table_column, {
              align: "center",
              prop: item.prop,
              label: item.label,
              "min-width": item.width,
              key: index
            }, null, 8, ["prop", "label", "min-width"]))
          }), 128)),
          _createVNode(_component_el_table_column, {
            label: "操作",
            align: "center",
            "min-width": "100"
          }, {
            default: _withCtx((scope) => [
              _createVNode(_component_el_button, {
                class: "bg-red",
                onClick: ($event: any) => (_ctx.recoverOrder(scope.row))
              }, {
                default: _withCtx(() => [
                  _hoisted_7
                ]),
                _: 2
              }, 1032, ["onClick"])
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["data", "header-cell-style"]), [
        [_directive_loading, _ctx.loading]
      ])
    ]),
    _createVNode("div", _hoisted_8, [
      _createVNode(_component_el_pagination, {
        onSizeChange: _ctx.handleSizeChange,
        onCurrentChange: _ctx.handleCurrentChange,
        "current-page": _ctx.currentPage,
        "page-sizes": [10, 20, 50, 100],
        "page-size": _ctx.pageSize,
        layout: "total, sizes, prev, pager, next, jumper",
        total: _ctx.total
      }, null, 8, ["onSizeChange", "onCurrentChange", "current-page", "page-size", "total"])
    ])
  ]))
}